import { bootManifestApp, loadBootManifestAppFromChannel } from "../../packages/platform-shell/src/index.js";
import * as pluginModule0 from "../../platform/plugins/platform-settings/index.js";
const loadPluginModule1 = () => import("../../apps/tutor/plugins/students/index.js");
const appManifest = {
  "appId": "tutor",
  "appName": "TUTOR",
  "runtime": "manifest-platform",
  "defaultTab": "platform.settings",
  "defaultScreenId": "",
  "authPolicy": "optional",
  "apiBaseUrl": "",
  "platformCore": {
    "mode": "workspace",
    "channel": "",
    "version": "",
    "minVersion": "",
    "manifestUrl": "",
    "rollbackVersion": ""
  },
  "uiTheme": {
    "appearanceId": "classic",
    "packId": "default",
    "defaultPackId": "default",
    "appScope": "tutor"
  },
  "shellPreset": "with-settings",
  "authBaseline": "without-auth-login",
  "shell": {
    "version": "v1",
    "layout": "sidebar-standard",
    "navMode": "plugin-tabs",
    "mobileNavMode": "stacked"
  },
  "baselines": [
    "platform.settings"
  ],
  "plugins": [
    "students"
  ],
  "resourceIsolation": "strict-app",
  "dependencyProfile": "platform-auth-core-v2-zero-n8n-no-email",
  "dependencyExtensions": [
    "cloudflare-direct-email"
  ],
  "previewAdapterId": "web-cloudflare-v1",
  "previewModes": [
    "demo-local",
    "real-local"
  ],
  "previewDataProfile": "default-demo-v1",
  "operations": {
    "ownerTeam": "unassigned",
    "serviceTier": "tier3",
    "reliabilityProfileId": "internal-standard-v1",
    "observabilityProfileId": "managed-cloudflare-v1",
    "deployPolicyId": "cloudflare-governed-v1",
    "runbookRefs": []
  },
  "settingsPlugin": {
    "visiblePanelsByRole": {
      "default": [
        "appearance"
      ],
      "admin": [
        "users",
        "sessions",
        "audit",
        "usage",
        "appearance",
        "archive"
      ]
    },
    "appearanceScopePolicy": {
      "default": "runtime-eligible",
      "admin": "runtime-eligible"
    },
    "appContribution": null
  },
  "testingEngine": {
    "v2": {
      "executionMode": "v2-only",
      "primaryPilot": false,
      "secondaryReference": false,
      "enabledLanes": {
        "model": true,
        "shell": true,
        "pluginAction": true,
        "workflow": true,
        "uiConsistency": true,
        "stress": false
      },
      "sizePolicy": {
        "presubmitBias": "small-medium",
        "largeLaneMaxPercent": 10
      },
      "hermeticPolicy": {
        "enforceForSmall": true,
        "enforceForMedium": true
      },
      "confidencePolicy": {
        "requireCoverageClosure": true,
        "requireConfidenceClosure": true
      },
      "quarantinePolicy": {
        "ttlDays": 14,
        "requireOwner": true
      },
      "ciPolicy": {
        "requiredChecks": [
          "app-test-plan",
          "app-test-runtime-critical",
          "app-test-coverage-closure",
          "app-test-confidence-closure"
        ]
      },
      "artifactPolicy": {
        "traceMode": "on-first-retry",
        "screenshotMode": "only-on-failure",
        "videoMode": "retain-on-failure"
      },
      "runtimeBacked": {
        "shell": {
          "enabled": false,
          "maxCases": 6,
          "maxWallClockSharePct": 15
        },
        "pluginAction": {
          "enabled": false,
          "criticalOnly": true,
          "maxCases": 12,
          "maxWallClockSharePct": 20
        },
        "workflow": {
          "enabled": false,
          "criticalOnly": true,
          "maxCases": 8,
          "maxWallClockSharePct": 20
        },
        "uiConsistency": {
          "enabled": false,
          "maxCases": 12,
          "maxWallClockSharePct": 25
        }
      },
      "migrationPolicy": {
        "primaryPromotionGate": false,
        "defaultForNewApps": true,
        "promotionWindowDays": 14,
        "sunsetWindow": "1-release-cycle"
      }
    },
    "enabled": true,
    "enforcementMode": "mandatory",
    "language": "js",
    "runner": "node:test",
    "generationMode": "hybrid",
    "dataMode": "synthetic-deterministic-factory",
    "obsoletePolicy": "quarantine-then-purge",
    "gatePolicy": "warn-only",
    "networkPolicy": "deny",
    "budgets": {
      "maxUnitCasesPerBehavior": 3,
      "maxIntegrationCasesPerBoundary": 3,
      "maxWorkflowCasesPerWorkflow": 3,
      "maxStressCasesPerApp": 25,
      "fuzzNDefault": 10,
      "fuzzNMax": 50,
      "maxAiEnrichedCasesPerBehavior": 5,
      "maxTotalGeneratedCasesPerApp": 2000,
      "maxGeneratedFilesPerSuite": 2000,
      "maxPlanOperationsPerSync": 5000,
      "maxScenarioVariantsPerScenario": 4,
      "maxStructuralFallbackCasesPerBehavior": 1,
      "timeBudgetSeconds": {
        "unit": 60,
        "integration": 120,
        "workflow": 120,
        "stress": 180,
        "verification": 120
      },
      "stressProfile": "standard"
    },
    "golden": {
      "enabled": true,
      "mode": "strict",
      "required": true,
      "maxGoldenFailuresToShow": 20
    },
    "business": {
      "enabled": false,
      "structuralFallbackPolicy": "only-uncovered",
      "requireConcreteAssertions": true,
      "minBusinessCoverageRatio": 0.8
    }
  }
};
const shellRuntimeConfig = null;
const pluginRegistry = {
  "platform.settings": { manifest: {"id":"platform.settings","name":"Settings","version":"1.0.0","apiVersion":"1.0.0","entry":"./index.js","tab":{"label":"Settings","order":90},"nav":{"hidden":false},"requiredCapabilities":[],"publishedCapabilities":[],"featureFlags":[]}, module: pluginModule0, loading: 'eager' },
  "students": { manifest: {"id":"students","name":"Students","version":"1.0.0","apiVersion":"1.0","entry":"./index.js","tab":{"label":"Students","order":20},"nav":{"hidden":false},"requiredCapabilities":[],"publishedCapabilities":[],"featureFlags":[]}, load: loadPluginModule1, prefetch: loadPluginModule1, loading: 'lazy' }
};
(async () => {
  const runtimeBoot = await loadBootManifestAppFromChannel({
    appManifest,
    fallbackBootManifestApp: bootManifestApp
  });
  await runtimeBoot({ appManifest, pluginRegistry, shellRuntimeConfig });
})().catch((error) => {
  console.error('[platform-shell] app bootstrap failed', error);
  throw error;
});